<video #target class="video-js" data-setup='{"fluid": true}'></video>
